"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFormatedForm = void 0;

var Yup = __importStar(require("yup"));

function getFormatedForm(model, defaultValues) {
  if (defaultValues === void 0) {
    defaultValues = {};
  }

  var schema = Yup.object().shape(Object.fromEntries(Object.entries(model).map(function (value) {
    return [value[0], value[1].schema];
  })));
  var initialValues = Object.fromEntries(Object.entries(model).map(function (value) {
    return [value[0], defaultValues[value[0]] == null ? '' : defaultValues[value[0]]];
  }));
  return [schema, initialValues];
}

exports.getFormatedForm = getFormatedForm;